// tool can be => "point" | "multipoint" | "polyline" | "polygon" | "rectangle" | "circle";
export default async function createSketch({
  graphicLayer,
  sketchVM,
  tool,
  setItem,
  onCreateExtraAction,
}) {
  graphicLayer?.removeAll();
  // eslint-disable-next-line no-param-reassign
  sketchVM.activeFillSymbol = {
    type: "simple-fill",
    style: "solid",
    color: [0, 0, 150, 0.1],
    outline: {
      color: [0, 0, 250],
      width: 2,
    },
  };

  sketchVM.create(tool);
  sketchVM.on("create", async (event) => {
    if (event.state === "start") {
      onCreateExtraAction();
    }
    if (event.state === "complete") {
      const geometries = graphicLayer.graphics.map(
        (graphic) => graphic.geometry
      );
      setItem(geometries.items[0]);
    }
  });
}
